import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { IFooter } from './footer.component.interface';
import { ICities, ISports, ISportsCollection } from './../../molecules/footer.nav/footer.nav.interface';

@Component({
    selector: 'mlp-ng-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class FooterSharedComponent {
    sportsFirst: ISportsCollection;
    sportsSecond: ISportsCollection;
    currentYear = new Date().getFullYear();

    @Input() data: IFooter;
    @Input() cities: Array<ICities>;
    @Input() city: string;
    private _sports: ISportsCollection;

    get sports(): ISportsCollection {
        return this._sports;
    }

    @Input()
    set sports(val: ISportsCollection) {
        if (val && val.data && val.data.length) {
            const fullSports = this.updateSports(val);
            this._sports = fullSports;
            this.sportsFirst = { data: fullSports.data.slice(0, 8) };
            this.sportsSecond = { data: fullSports.data.slice(8) };
        }
    }

    updateSports(sports: ISportsCollection): ISportsCollection {
        const data = sports.data.map((sport: ISports) => {
            sport.attributes.slug = `${this.city}/${sport.id}`;

            return sport;
        });

        return { data };
    }
}
